import {Button} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';

import brandedButtonStyles from './style';

/**
 * Zoom Branded Button Component
 * @param {Object} props
 * @return {ReactElement}
 */
const BrandedButton = withStyles(brandedButtonStyles)(Button);

export default BrandedButton;
